<template>
    <div class="entry-content">
        <form @submit.prevent="handleFormSubmit">
            <h2>Information</h2>
            <input type="text" v-model="name" placeholder="Criteria Name" maxlength="400" required>
            <h2>Required Grade</h2>
            <input type="number" min="1" max="3" v-model="grade" placeholder="Required Grade" required>
            <h2>Order</h2>
            <input type="number" min="1" v-model="order" placeholder="Criteria Order">
            <div class="form-footer-wrapper">
                <button type="button" class="cancel" @click.prevent="handleRedirect">Cancel</button>
                <input type="submit" class="save" value="Add" />
            </div>
        </form>
    </div>
</template>

<script>
import CheckApi from '@/api'

export default {
    name: 'AddLesson',
    data() {
		return {
            name: '',
            grade: '',
            order: ''
        }
    },
    methods: {
        async handleFormSubmit() {
            const {
                unitTemplateId,
                courseTemplateId,
                lessonTemplateId,
                elementTemplateId,
            } = this.$route.params
            await CheckApi.createCriteriaTemplate({name: this.name, elementTemplateId: parseInt(elementTemplateId), orderNumber: this.order, requiredGrade: this.grade})
            this.$router.push(`/templates/${courseTemplateId}/lessons/${lessonTemplateId}/units/${unitTemplateId}/elements/${elementTemplateId}?page=1`)
        },
        handleRedirect() {
            this.$router.go(-1)
        }
    }
}
</script>

<style lang="scss" scoped>
.form-footer-wrapper {
        display: flex;
        justify-content: flex-end;
    }

    .cancel {
        background-color: transparent;
        border: .0625em solid #141638;

        &:hover {
            color: #141638;
        }
    }

    .cancel,
    .save {
        width: 100px !important;
        height: 30px !important;
        border-radius: .75em !important;
        text-align: center !important;
        cursor: pointer;
    }

    .save {
        margin-left: 15px;
        background-color: #08ce97;
        border-style: none;
        color: #fff;
        border-radius: 0.75em;
        display: block !important;
        margin: 0 !important;
        margin-left: 15px !important;
        padding: 5px;
    }
</style>